<div class="row mt-3 mb-3">
  <div class="col-12">
    <button (click)="adicionar()" #btnAdicionar class="btn btn-sm btn-outline-primary">
      <img src="assets/img/global/plus.png" alt="adicionar" title="Adicionar" height="16" width="16">
      Adicionar
    </button>
  </div>
</div>
<table class="table table-eddy">
  <thead>
    <tr>
      <th style="width: 60%" scope="col">Pessoa</th>
      <th scope="col">Licitação</th>
      <th scope="col">Resp. Contrato</th>
      <th scope="col"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of listaMembros; let idx = index">
      <td *ngIf="!item.editavel" style="width: 60%">{{item.pessoa.nome}}</td>
      <td *ngIf="!item.editavel">
        <span *ngIf="item.licitacao" class="badge badge-success">Sim</span>
        <span *ngIf="!item.licitacao" class="badge badge-danger">Não</span>
      </td>
      <td *ngIf="!item.editavel">
        <span *ngIf="item.responsavel_contrato" class="badge badge-success">Sim</span>
        <span *ngIf="!item.responsavel_contrato" class="badge badge-danger">Não</span>
      </td>

      <td *ngIf="item.editavel" style="width: 60%">
        <p-autoComplete [(ngModel)]="itemAtual.pessoa" [forceSelection]="true" [autoHighlight]="true"
          [ngModelOptions]="{standalone: true}" [field]="pessoaAutoComplete.conversor"
          [suggestions]="pessoaAutoComplete.lista" (completeMethod)="pessoaAutoComplete.filtrar($event)"
          inputStyleClass="form-control form-control-sm" minLength="2"
          [style]="{ width: 'calc(100% - 36px)', float: 'left' }">
          <ng-template let-pessoa pTemplate="item">
            {{pessoa.cpf_cnpj | CPF}} - {{pessoa.nome}}
          </ng-template>
        </p-autoComplete>
        <button class="btn btn-sm btn-outline-secondary float-right" type="button" data-toggle="modal"
          style="border-bottom-left-radius: 0px;  border-top-left-radius: 0px;" data-target="#dialogPessoa">
          <i class="fa fa-user-plus"></i>
        </button>
      </td>
      <td *ngIf="item.editavel">
        <div class="checkbox checbox-switch switch-success">
          <label>
            <input type="checkbox" [(ngModel)]="itemAtual.licitacao"
              [ngModelOptions]="{standalone: true}" /><span></span>
          </label>
        </div>
      </td>
      <td *ngIf="item.editavel">
        <div class="checkbox checbox-switch switch-primary">
          <label>
            <input type="checkbox" [(ngModel)]="itemAtual.responsavel_contrato"
              [ngModelOptions]="{standalone: true}" /><span></span>
          </label>
        </div>
      </td>

      <td class="text-right">
        <button *ngIf="item.editavel" (click)="salvar(item)" class="btn btn-sm btn-outline-secondary mr-2">
          <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
        </button>
        <button *ngIf="item.editavel" (click)="cancelar(item)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/cross.png" alt="editar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel" (click)="editar(item)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel" (click)="remover(item)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
        </button>
      </td>
    </tr>
  </tbody>
</table>

<lib-pessoa-cadastro-dlg *ngIf="itemAtual && itemAtual.pessoa" [entity]="itemAtual.pessoa" [login]="login">
</lib-pessoa-cadastro-dlg>